import { Accident } from "./accident";

export class AccidentsGroup {
  accidents: Array<Accident>;
  constructor(accidents: Array<Accident>) {
    this.accidents = accidents
  }

  isMultiple(): boolean {
    return this.accidents.length > 1
  }

  belongs(closeByAccident: Accident): boolean {
    const distance = this.accidents[0].location.distanceFrom(closeByAccident.location)
    return distance[0] <= 0.000800 && distance[1] <= 0.001000
  }

  add(newAccident: Accident): void {
    this.accidents.push(newAccident)
  }

  hasDead(): boolean {
    return this.accidents.find(accident => accident.dead > 0) !== undefined
  }

  isTragic(): boolean {
    return this.accidents.find(accident => accident.isTragedy()) !== undefined
  }

  isMiraculous(): boolean {
    return !this.isTragic()
  }

  miraclesOnly(): AccidentsGroup {
    return new AccidentsGroup(this.accidents.filter(accident => accident.isMiracle()))
  }
}
